import { defineStore } from "pinia";
import { ref } from "vue";
import { INSPECTION_LINKS_ENDPOINT } from "@/constants/Endpoints";
import axios from "axios";
import { LOGGER } from "@/util/logger";
import { clone } from "@/util/clone";
import { MODULE_TYPES } from "@/constants/InspectionConstants";

export const useTunnelsStore = defineStore("tunnels", () => {
  //tunnels data is loaded either from idb (pouch db for inspection module) or service (for management module)
  let tunnelsData = ref({});

  const loadTunnelsObject = async (moduleType, quickSearchData, structure) => {
    let isSuccess = false;
    if (moduleType === MODULE_TYPES.INSPECTION) {
      //if moduleType is inspection, load data from pouchDB
      convertToInspModuleObject(structure);
      isSuccess = true;
    } else if (moduleType === MODULE_TYPES.MANAGEMENT && quickSearchData.BRKEY && quickSearchData.INSPECTIONID) {
      //if moduleType is management, load data from service call
      isSuccess = await getInspLinkTunnels(quickSearchData);
    }
    return isSuccess;
  };

  const getTunnelsObject = () => {
    return clone(tunnelsData.value);
  };

  const convertToInspModuleObject = (tunnels) => {
    tunnelsData.value = tunnels;
  };

  const getInspLinkTunnels = async (quickSearchData) => {
    //clear idb object
    tunnelsData.value = {};
    let isSuccess = false;
    const { BRKEY, INSPECTIONID } = quickSearchData;
    let url = INSPECTION_LINKS_ENDPOINT.GET_TUNNELS.replace("{brkey}", BRKEY).replace("{inspectionId}", INSPECTIONID);

    await axios
      .get(url)
      .then((resp) => {
        isSuccess = true;
        convertToInspLinkObject(resp.data.data, quickSearchData);
      })
      .catch((e) => {
        LOGGER.logException(e);
      });
    return isSuccess;
  };

  const convertToInspLinkObject = (tunnels, quickSearchData) => {
    const { BRKEY, INSPECTIONID, SERVTYPON } = quickSearchData;
    const {
      numBores,
      tunnelShape,
      portalShape,
      groundCondition,
      complex,
      svcInTunnel,
      dirOfTraffic,
      toll,
      functionalClass,
      urbanCode,
      inspTargetDate,
      inDepthInspSchedule,
      heightRestr,
      hazmatRestr,
      otherRestr,
      damageInspPerformed,
      specialInspScheduled,
    } = tunnels;
    tunnelsData.value = {};
    const obj = {
      structureBridge: { brkey: BRKEY, servTypOn: SERVTYPON },
      inspection: { inspectionId: INSPECTIONID },
      structureUnits: tunnels?.structureUnits,
      inspectionElementPons: tunnels?.inspectionElementPons,
      structureTunnelMaterial: {
        numBores,
        tunnelShape,
        portalShape,
        groundCondition,
        complex,
      },
      tunnelService: {
        svcInTunnel,
        dirOfTraffic,
        toll,
        functionalClass,
        urbanCode,
        inspTargetDate,
        inDepthInspSchedule,
        damageInspPerformed,
        specialInspScheduled,
      },
      tunnelLoadRating: { heightRestr, hazmatRestr, otherRestr },
    };

    tunnelsData.value = obj;
  };

  return {
    tunnelsData,
    getTunnelsObject,
    loadTunnelsObject,
  };
});
